import React, { useState } from 'react';
import { SdmDialog, SdmTextButton, SdmTypography } from 'components';
import CustomMultiFileCropper from '../styledComponents/FileCropper/CustomMultiFileCropper';

function MultiFileCropperDialog({
  onClose,
  onAccept,
  i18n,
  imgs,
  maxHeight,
  minHeight,
  minWidth,
  maxWidth,
}) {
  const [files, setFiles] = useState([]);
  const [currentFileIdx, setCurrentFileIdx] = useState(0);
  const isLastImg = currentFileIdx === imgs?.length - 1;

  const renderTitle = () => {
    return (
      <div style={{ width: '100%', marginTop: 16 }}>
        <SdmTypography
          variant={'h1'}
          style={{ textAlign: 'center', marginTop: 20, marginBottom: 0 }}
        >
          {i18n.title}
        </SdmTypography>
      </div>
    );
  };

  const handleNextImg = () => {
    if (isLastImg) onAccept(files);
    else setCurrentFileIdx((prev) => prev + 1);
  };

  const handlePrevImg = () => {
    setCurrentFileIdx((prev) => prev - 1);
  };

  const handleFileCropped = (file) => {
    const blobURL = window.URL.createObjectURL(file);
    const img = new Image();
    img.src = blobURL;
    img.onload = function () {
      window.URL.revokeObjectURL(blobURL); // release memory
      // Use the img
      const canvas = document.createElement('canvas');
      const actualWidth = this.width;
      const actualHeight = this.height;
      const ratio = actualWidth / actualHeight;
      const parsedWidth = ratio * maxHeight;
      const adjustedHeight = maxHeight;
      const adjustedWidth =
        parsedWidth > maxWidth
          ? maxWidth
          : parsedWidth < minWidth
          ? minWidth
          : parsedWidth;
      canvas.width = adjustedWidth;
      canvas.height = adjustedHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, adjustedWidth, adjustedHeight);
      canvas.toBlob((blob) => {
        const resizedFile = new File(
          [blob],
          file.name.replace(/[^a-z0-9.]/gi, '_'),
          {
            type: file.type,
          }
        );
        const _next = [...files];
        _next[currentFileIdx] = resizedFile;
        setFiles(_next);
      }, file.type);
    };
  };

  return (
    <SdmDialog
      open
      onClose={onClose}
      title={renderTitle()}
      paperStyle={{
        borderRadius: 15,
        paddingBottom: 16,
        margin: 0,
      }}
      closeIconContainerStyle={{
        top: 15,
        right: 20,
        transform: 'scale(1.5)',
      }}
      actionContainerStyle={{ justifyContent: 'center' }}
      titleStyle={{ padding: 0 }}
      contentStyle={{
        paddingTop: 16,
        paddingBottom: 22,
        flex: 'none',
        margin: '0 auto',
      }}
      showTitleDivider={false}
      handleBody={false}
      maxWidth={false}
      customActions={
        <div>
          <SdmTextButton
            onClick={() => handlePrevImg()}
            disabled={currentFileIdx === 0}
            text={i18n.prev}
            style={{ height: 40, width: 158, margin: 0, marginRight: 25 }}
            textStyle={{ fontSize: 20 }}
            variant={'red'}
          />
          <SdmTextButton
            onClick={() => handleNextImg()}
            disabled={false}
            text={isLastImg ? 'Ok' : i18n.next}
            style={{ height: 40, width: 158, margin: 0 }}
            textStyle={{ fontSize: 20 }}
            variant={'redFill'}
          />
        </div>
      }
    >
      <div
        style={{
          textAlign: 'center',
          fontSize: 20,
        }}
      >
        {i18n.body}
        {currentFileIdx >= -1 ? (
          <CustomMultiFileCropper
            img={imgs[currentFileIdx]}
            previewTitle={i18n.preview}
            style={{
              marginTop: 40,
            }}
            onFileCropped={handleFileCropped}
            maxHeight={maxHeight}
            minHeight={minHeight}
            minWidth={minWidth}
            maxWidth={maxWidth}
          />
        ) : null}
      </div>
    </SdmDialog>
  );
}

export default MultiFileCropperDialog;
